import { getThemeColor } from 'style-utils/theme/utils/getThemeColor';
import styled from 'styled-components';

export const SingleStepWrapper = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child)::after {
    content: '';
    display: block;
    width: 22.9px;
    height: 1px;
    border-radius: 1px;
    background-color: ${getThemeColor('bgPrimary')};
  }
`;

SingleStepWrapper.displayName = 'SingleStepWrapper';
